import { useState, useCallback } from 'react';
import { useSnackbar } from '../context/SnackbarContext';
import api from '../api/axiosInstance'; // Axios instance handles BaseURL and Auth Headers

export const useStaffManager = (fetchUrl) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const showSnackbar = useSnackbar();

    // 1. MIGRATED TO AXIOS
    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            // Axios handles the 'Bearer' token via interceptors
            const res = await api.get(fetchUrl);
            // Axios data is directly in .data
            setUsers(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error("Fetch Users Error:", err);
            showSnackbar('Failed to load users', 'error');
        } finally {
            setLoading(false);
        }
    }, [fetchUrl, showSnackbar]);

    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    // 2. FIXED AXIOS LOGIC
    const handleAction = async (url, method, payload = null, successMsg) => {
        try {
            await api({
                url: url,
                method: method,
                data: payload // Changed from 'body' to 'payload' to match your function signature
            });

            // Axios considers any 2xx status as success
            showSnackbar(successMsg, 'success');
            fetchUsers(); // Refresh the list
            return true;
            
        } catch (err) {
            // Axios error handling: look for the message sent by your Express backend
            const errorMsg = err.response?.data?.message || 'Action failed';
            showSnackbar(errorMsg, 'error');
            return false;
        }
    };

    return {
        users,
        loading,
        fetchUsers,
        handleAction,
        showPassword,
        togglePasswordVisibility
    };
};